import { render, staticRenderFns } from "./VsStackedBarChart.vue?vue&type=template&id=b6ecd560&"
import script from "./VsStackedBarChart.vue?vue&type=script&lang=js&"
export * from "./VsStackedBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports